import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const IDEAL: PaymentMethod = {
    id: PAYMENT_METHOD_ID.IDeal,
    name: 'ideal',
    displayName: 'iDEAL'
};
